export default function getXSRFToken(): string {
  const cDecoded = decodeURIComponent(document.cookie)
  const cookieArray = cDecoded?.split('; ')

  const result = cookieArray?.filter(value => value.includes('XSRF-TOKEN'))

  const xsrfToken = result[0]?.split('=').pop()

  return xsrfToken || ''
}
